import { apolloClient } from '~/apollo-client';
import {
  ContractTag,
  Flex_FetchUsageRequestFormQuery,
  Flex_FetchUsageRequestFormQueryVariables,
} from '~/typings/graphql';
import { FETCH_USAGE_REQUEST_FORM } from './fetch-usage-request-form.queries';

export const fetchUsageRequestForm = async (
  params: FetchUsageRequestFormParams,
): Promise<FetchUsageRequestFormResponse> => {
  const { stateId, communitySolarProjectGroupId, contractTags } = params;

  const { data } = await apolloClient.query<
    Flex_FetchUsageRequestFormQuery,
    Flex_FetchUsageRequestFormQueryVariables
  >({
    query: FETCH_USAGE_REQUEST_FORM,
    variables: {
      stateId,
      communitySolarProjectGroupId,
      ...(contractTags && contractTags.length > 0 ? { tags: contractTags } : {}),
    },
  });

  const { usageRequestForm } = data;

  return {
    docuSignContracts: usageRequestForm ? [usageRequestForm] : [],
  };
};

export type ContractVersion = {
  contractId: number;
  contractType: string;
  displayName: string;
  fileUrl: string;
  hasPersonalization?: boolean | null;
  id: number;
  scrollRequired: boolean;
  tag?: ContractTag | null;
  contractVersionLanguageId?: number | null;
  signatureType?: string;
};

export type FetchUsageRequestFormParams = {
  stateId: number;
  communitySolarProjectGroupId?: number | null;
  contractTags?: ContractTag[];
};

export interface FetchUsageRequestFormResponse {
  docuSignContracts: ContractVersion[];
  showUsageRequest?: boolean;
}
